import service from "./service";

/**
 * GetRootDatasets
 * @param {number} payload
 */
async function getRootDatasets(payload) {
    try {
    const res = await service.getRootDatasets(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * createRootDataset
 * @param {number} payload.projectId
 * @param {string} payload.storageType
 */
async function createRootDataset(payload) {
    try {
    const res = await service.createRootDataset(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * getDatasetsOfTree
 * @param {number} payload
 */
async function getDatasetsOfTree(payload) {
    try {
    const res = await service.getDatasetsOfTree(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * GetDatasetContents
 * @param {number} payload.datasetId
 * @param {string} payload.keyword
 * @param {number} payload.page
 * @param {number} payload.limit
 * @param {string} payload.sort
 */
async function getDatasetContents(payload) {
    try {
    const res = await service.getDatasetContents(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * createDataset
 * @param {number} payload.parentDatasetId
 * @param {string} payload.datasetName
 * @param {number} payload.projectId
 */
async function createDataset(payload) {
    try {
    const res = await service.createDataset(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * createDatasetRecursively
 * @param {number} payload.ancestorDatasetId
 * @param {string} payload.datasetPath
 * @param {number} payload.uploadId
 */
async function createDatasetRecursively(payload) {
    try {
    const res = await service.createDatasetRecursively(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * createUpload
 * @param {string} payload.purpose
 */
async function createUpload(payload) {
    try {
    const res = await service.createUpload(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * createUploadFailure
 * @param {number} uploadId
 * @param {number} datasetId
 * @param {string} name
 * @param {string} failureType
 */
async function createUploadFailure(payload) {
    try {
    const res = await service.createUploadFailure(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * stopUpload
 * @param {boolean} payload.success
 * @param {number} payload.uploadId
 */
async function stopUpload(payload) {
    try {
    const res = await service.stopUpload(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * startUpload
 * @param {number} payload.uploadId
 * @param {number} payload.datasetId
 */
async function startUpload(payload) {
    try {
    const res = await service.startUpload(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * syncStart
 * @param {number} payload.uploadId
 * @param {number} payload.datasetId
 */
async function syncStart(payload) {
    try {
    const res = await service.syncStart(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * getUserUploads
 * @param {number} payload.projectId
 */
async function getUserUploads(payload) {
    try {
    const res = await service.getUserUploads(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * getUploadProgress
 * @param {number} payload.uploadId
 */
async function getUploadProgress(payload) {
    try {
    const res = await service.getUploadProgress(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * getUploadFailures
 * @param {number} payload.uploadId
 * @param {number} payload.datasetId
 * @param {number} payload.page
 * @param {number} payload.limit
 */
async function getUploadFailures(payload) {
    try {
    const res = await service.getUploadFailures(payload);
    return res;
    } catch (error) {
    return null;
    }
}

export default {
    getRootDatasets,
    createRootDataset,
    getDatasetsOfTree,
    getDatasetContents,
    createDataset,
    createDatasetRecursively,
    createUpload,
    createUploadFailure,
    stopUpload,
    startUpload,
    syncStart,
    getUserUploads,
    getUploadProgress,
    getUploadFailures,
};
